<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ProductCompletion :product="product" />
  <RouterView :product="product" />
</template>
<script setup lang="ts">
import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { ProductCompletion } from '@/components/ProfileCompletion'
import { useReviewsProductBreadcrumbs } from '@/composables/breadcrumbs/useReviewsProductBreadcrumbs'
import type { ProductData } from '@/gql/reviews'

const props = defineProps<{
  product: ProductData
}>()

const breadcrumbs = useReviewsProductBreadcrumbs(props.product)
</script>
